import { Injectable, ElementRef } from '@angular/core';
import { ColorPickerComponent } from './color-picker.component';
import { MatDialog } from '@angular/material/dialog';
import { dialogType } from '@core_n/enums';

@Injectable({
  providedIn: 'root'
})
export class ColorPickerService {

  constructor(private dialog: MatDialog)
  {
  }

  showColorPicker(relativeToElement: ElementRef, selectedColor?: string): Promise<string> {
    return this.dialog.open(ColorPickerComponent,
      ColorPickerComponent.createDialogConfig(relativeToElement, selectedColor)).afterClosed().toPromise();
  }

  isColorPickerShown(): boolean {
    return this.dialog.getDialogById(dialogType.colorPicker) !== undefined;
  }
}
